import { FC, useState } from 'react'
import { UpgradePlanModal } from 'src/components/UpgradePlanModal'
import { useGetUserFeaturesQuery } from 'src/reactQuery/useGetUserFeaturesQuery'
import { EmptyState } from './EmptyState'
import { AdLibraryMain } from './Main'

export const AdLibrary: FC = () => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  const { data: userFeatures } = useGetUserFeaturesQuery()
  const adsLibraryEnabled = userFeatures?.data?.adsLibraryEnabled ?? true

  if (!adsLibraryEnabled) {
    return (
      <>
        <EmptyState onEnableClick={() => setIsUpgradeModalOpen(true)} />
        <UpgradePlanModal
          isOpen={isUpgradeModalOpen}
          setIsOpen={setIsUpgradeModalOpen}
        />
      </>
    )
  }

  return <AdLibraryMain />
}
